module.exports = __webpack_public_path__ + "resources/img/solution_finance_rescue2_m.047155a16b3e9ad75830a414799f840d.png";